/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Short_ShipmentsInputs */

const en_nav_short_shipments = /** @type {(inputs: Nav_Short_ShipmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short shipments`)
};

/**
* | output |
* | --- |
* | "Short shipments" |
*
* @param {Nav_Short_ShipmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_short_shipments = /** @type {((inputs?: Nav_Short_ShipmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Short_ShipmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_short_shipments(inputs)
});